import {getClient} from "./axiosClient";

const client = getClient()

export default async function getUsersForCompany(companyId)
{
    return await client.get(`v1/users/${companyId}`)
}

export async function registerUser(user, companyId)
{
    const request = {...user, companyId: companyId}
    return await client.post('v1/users', request)
}

export async function inviteUser(user, companyId)
{
    const request = {...user, companyId: companyId}
    return await client.post('v1/users/invite', request)
}

export async function updateUser(userId, params) {
    return await client.patch(`v1/users/${userId}`, params)
}

export async function deleteUser(userId)
{
    return await client.delete(`v1/users/${userId}`)
}

export async function getRoles()
{
    return await client.get('v1/users/roles')
}

export async function getClaimsForUser(userId)
{
    return await client.get(`v1/users/${userId}/permissions`)
}